// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defer } from 'lodash/fp';

// Components
import BoardListItem from '../../../../components/popupPanel/listItems/BoardListItem';
import Icon from '../../../../components/icons/Icon';

// Util
import branchSingular from '../../../../../common/utils/lib/branchSingular';

// Styles
import './ElementSearchResultQuickNotes.scss';

const pluralMatch = branchSingular('match', 'matches');

const SearchResultQuickNotes = ({
    board,
    resultsCount,
    linkUrl,
    gridSize,
    setFocusIndex,
    focusOnInput,
    index,
    openQuickNotes,
    closeSearch,
}) => (
    <BoardListItem
        className={classNames('QuickNotesSearchResult')}
        figure={<Icon name="nav-quick-notes" />}
        gridSize={gridSize}
        linkUrl={linkUrl}
        onClick={() => {
            defer(() => {
                closeSearch && closeSearch();
                openQuickNotes && openQuickNotes();
            });
        }}
        board={board}
        active
    >
        <div className="message">
            <div className="results">
                {resultsCount ? `${resultsCount} ${pluralMatch(resultsCount)} in your Quick Notes` : null}
            </div>
        </div>
    </BoardListItem>
);

SearchResultQuickNotes.propTypes = {
    currentBoardId: PropTypes.string,
    board: PropTypes.object,
    searchQuery: PropTypes.string,
    linkUrl: PropTypes.string,
    resultsCount: PropTypes.number,
    gridSize: PropTypes.number,
    index: PropTypes.number,

    setFocusIndex: PropTypes.func,
    focusOnInput: PropTypes.func,
    openQuickNotes: PropTypes.func,
    closeSearch: PropTypes.func,
};

export default SearchResultQuickNotes;
